import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { getGroupsList } from '../../api/getGroupsList';

import HeaderTopic from "./../../partials/HeaderTopic";
import FooterMenu from "../../partials/FooterMenu";
import BasicButtons from "../../partials/BasicButtons";
import ShowGroupCube from "./ShowGroupCube";

import styles from "./GroupsList.module.css";
import brandPlus from "../../graphics/elements/brandedPlus.png";


function GroupsList(props) {
  const { user, league, teams, setTeams, refreshStates } = props;
  let history = useHistory();
  const { leagueId } = useParams();

  React.useEffect(() => {
    let mounted = true;

    getGroupsList(leagueId).then((data) => {
      mounted && setTeams(data);
    });

    return function cleanup() {
      mounted = false;
    };
  }, [leagueId, setTeams]);

  const topic = `ליגת ${league?.name}`;
  const allGroupsCubes = teams.map((group) => (
    <ShowGroupCube key={group.id} groupObj={group} />
  ));

  return (
    <div className={styles.groupsList}>
      <HeaderTopic topic={topic} />
      <FooterMenu setActive="league" />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <div className={styles.bgVisual}></div>
      <div className={styles.list}>
        {user.is_leagues_manager && (
          <img
            src={brandPlus}
            onClick={() => {
              history.push(`/leagues/${leagueId}/addgroup`);
            }}
            alt="הוספת קבוצה חדשה"
          />
        )}
        <div className={styles.groupsFlex}>{allGroupsCubes}</div>
        <p className={styles.notFoundText}>
          לא מוצא את הקבוצה שלך? דבר עם רכז הליגה!
        </p>
      </div>
    </div>
  );
}



export default GroupsList;
